import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from 'react-router-dom'

import Container from '@mui/material/Container'
import Fab from '@mui/material/Fab'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import SaveIcon from '@mui/icons-material/Save'

import { ThemeContext, UserContext } from 'components/common/App'

import rpc, { buildRequest, signoutAndRedirectToIndex } from 'lib/rpc'

import MascotForm from '../MascotForm'

export default function MascotCreatePage() {
  const theme = useContext(ThemeContext)
  // Creating a mascot is superuser-only (#290).
  const currentUser = useContext(UserContext)
  const isSuperuser = currentUser && currentUser.role === "superuser"
  const navigate = useNavigate()

  const form = useRef({ payload: () => ({}), isValid: false })
  const [isValid, setIsValid] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)

  useEffect(() => {
    theme.changeTheme("light-bg")
    window.scrollTo(0, 0)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onFormChange = useCallback(({ payload, isValid }) => {
    form.current = { payload: () => payload, isValid }
    setIsValid(isValid)
  }, [])

  const submitForm = () => {
    if (!form.current.isValid) {
      return
    }
    rpc.post(
      "",
      buildRequest("admin.mascots.create", form.current.payload())
    ).then(response => {
      if (!response.data.result.message) {
        navigate(`/mascots/details/${response.data.result.id}`)
      } else {
        if (response.data.result.code === 5) {
          signoutAndRedirectToIndex()
        }
        setErrorMessage(response.data.result.message)
      }
    })
  }

  return (
    <>
      <Helmet>
        <title>Create Mascot</title>
      </Helmet>

      {isSuperuser && (
        <Fab
          color="primary"
          aria-label="save"
          sx={{ position: 'fixed', bottom: 16, right: 16 }}
          disabled={!isValid}
          onClick={submitForm}
        >
          <SaveIcon />
        </Fab>
      )}

      <Container fixed>
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="h4" component="h1" gutterBottom>
            New Mascot
          </Typography>
        </Stack>
        <MascotForm errorMessage={errorMessage} onChange={onFormChange} />
      </Container>
    </>
  )
}
